import React from "react";
// PHONE NUMBER REACT
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { FormularyRowPhoneNumberInterface } from "../../../interfaces/FormularyRow";
import { RootState } from "../../../app/store";

export default function FormularyRowPhoneNumber({
  record,
  text,
  value,
  formAction,
  itemId,
  textLink,
  onChangeFormValue,
}: FormularyRowPhoneNumberInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getDropDownThemeColor = () => {
    if (theme === "light") {
      return "#d9d9d9";
    }
    if (theme === "dark") {
      return "#2a2a2a";
    }
    if (theme === "blue") {
      return "#16314d";
    }
    return "";
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <>
      {record.id === "" ? (
        <PhoneInput
          country="us"
          enableAreaCodes
          value={formAction === "create" ? value : ""}
          onChange={(event: any) => {
            onChangeFormValue(event, "phone");
          }}
          // Set your inline styles here
          containerStyle={{
            borderColor: `${theme === "light" ? "#d9d9d9" : "#434343"}`,
          }}
          inputStyle={{
            background: "transparent",
            borderColor: `${theme === "light" ? "#d9d9d9" : "#434343"}`,
            color: `${theme === "light" ? "black" : "white"}`,
            width: "100%",
            height: "7px",
            borderRadius: "0px",
          }}
          dropdownStyle={{
            backgroundColor: `${getDropDownThemeColor()}`,
          }}
        />
      ) : (
        <>
          {formAction === "edit" && record.id === itemId ? (
            <PhoneInput
              country="us"
              enableAreaCodes
              value={value}
              onChange={(event: any) => {
                onChangeFormValue(event, "phone");
              }}
              // Set your inline styles here
              containerStyle={{
                borderColor: `${theme === "light" ? "#d9d9d9" : "#434343"}`,
              }}
              inputStyle={{
                background: "transparent",
                borderColor: `${theme === "light" ? "#d9d9d9" : "#434343"}`,
                color: `${theme === "light" ? "black" : "white"}`,
                width: "100%",
                height: "7px",
                borderRadius: "0px",
              }}
              dropdownStyle={{
                backgroundColor: `${getDropDownThemeColor()}`,
              }}
            />
          ) : (
            <div className={textLink ? "generalStyles__info" : ""}>{text}</div>
          )}
        </>
      )}
    </>
  );
}
